export default __webpack_public_path__ + "static/media/powerpoint.07cdcb94.png";